import { z } from 'zod';

import { LevelEnum } from '../../enums';
import { PaginationQuerySchema } from '../pagination';

export const SentencesQuerySchema = PaginationQuerySchema.extend({
  levels: z
    .preprocess(
      (val) => {
        if (typeof val === 'string' && val.length > 0) {
          return val.split(',');
        }
        return Array.isArray(val) ? val : undefined;
      },
      z.array(z.nativeEnum(LevelEnum)).optional(),
    )
    .describe('Filter sentences by an array of CEFR levels (e.g., A1,A2).'),
  text: z.string().optional().describe('Filter sentences by text content.'),
});

export type ISentencesQueryDto = z.infer<typeof SentencesQuerySchema>;
